import React from 'react';
import _ from 'lodash';

import styles from './feeStructureStyles';

import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';

const FeeStructure = ({ fundProfile }) => {
  const {
    managementFee,
    incentiveFee,
    hurdleRate,
    lockUp,
    highwaterMark,
    seedDeal,
    foundersShares,
    investorLevelGates,
    feeStructureDocuments
  } = fundProfile;
  const yesNo = attr => (attr ? 'Yes' : attr === false ? 'No' : 'N/A');
  const formatPercent = attr => (_.isNumber(attr) ? `${attr}%` : 'N/A');
  const formatMonths = attr => (_.isNumber(attr) ? `${attr} Mo.` : 'N/A');
  const rows = [
    [
      { label: 'Management Fee', value: formatPercent(managementFee) },
      { label: 'Highwater Mark', value: yesNo(highwaterMark) }
    ],
    [
      { label: 'Incentive Fee', value: formatPercent(incentiveFee) },
      { label: 'Seed Deals', value: yesNo(seedDeal) }
    ],
    [
      { label: 'Hurdle Rate', value: formatPercent(hurdleRate) },
      { label: "Founder's Shares", value: yesNo(foundersShares) }
    ],
    [
      { label: 'Lock Up', value: formatMonths(lockUp) },
      { label: 'Investor-Level Gates', value: yesNo(investorLevelGates) }
    ]
  ];
  return (
    <div className={styles.feeStructureContainer}>
      {rows.map((row, idx) => (
        <div key={idx} className={styles.feeStructureRow}>
          {row.map((item, idx) => (
            <div key={idx} className={styles.feeStructureItem}>
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      ))}
      {!_.isEmpty(feeStructureDocuments) && !!feeStructureDocuments.length && (
        <DocumentList
          title="Supporting Documents"
          documents={feeStructureDocuments}
          urlFn={employerProfileDocumentUrl}
        />
      )}
    </div>
  );
};

export default FeeStructure;
